import { ReactElement, useEffect, useRef } from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import ItemValue from "./itemValue";
import { IComponentProps } from "./types";
import Header from "./header";

const EafComponent = ({ realtime, overviewData, updateOverview, firstTime }: IComponentProps): ReactElement => {
  const heatNumber = useRef<any>(null);
  const actualHeatNumber = realtime["MS.EAF.N2.ACTUAL_HEAT_NUMBER_LS"];

  useEffect(() => {
    if (actualHeatNumber && actualHeatNumber.Value !== heatNumber.current) {
      if (heatNumber.current !== null && !firstTime) {
        updateOverview("EAF");
      }

      heatNumber.current = actualHeatNumber.Value;
    }
  }, [actualHeatNumber]);

  return (
    <Card style={{ background: "rgba(0, 0, 0, .3)" }}>
      <CardHeader className="p-1 justify-content-" title="EAF" style={{ background: "rgba(82,99,108, 1)" }} />
      <CardContent className="p-0" >
        <Header overviewData={overviewData} />
        <div className="display-grid gap-1 p-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
          <div className="display-grid justify-content-start align-content-center">
            <strong>GENERAL</strong>
          </div>
          <ItemValue title="KWH" value={realtime["MS.EAF.KWH"]?.Value} color="green"/>
          <ItemValue title="INCLINOMETER" value={realtime["MS.EAF.INCLINOMETER"]?.Value} color="green"/>
          <div/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>CURRENT</strong>
          </div>
          <ItemValue title="PHASE 1" value={realtime["MS.EAF.PHASE_CURR1"]?.Value} color="green"/>
          <ItemValue title="PHASE 2" value={realtime["MS.EAF.PHASE_CURR2"]?.Value} color="green"/>
          <ItemValue title="PHASE 3" value={realtime["MS.EAF.PHASE_CURR3"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>VOLTAGE</strong>
          </div>
          <ItemValue title="PHASE 1" value={realtime["MS.EAF.PHASE_SEC_VOL1"]?.Value} color="green"/>
          <ItemValue title="PHASE 2" value={realtime["MS.EAF.PHASE_SEC_VOL2"]?.Value} color="green"/>
          <ItemValue title="PHASE 3" value={realtime["MS.EAF.PHASE_SEC_VOL3"]?.Value} color="green"/>


        </div>
      </CardContent>
    </Card>
  );
};

export default EafComponent;